<template>
  <div class="row">
    <div class="col-md">
      <table class="table table-striped">
        <tr><td><b>Artikel-ID:</b></td><td>{{ article.map_id }}</td></tr>
        <tr><td><b>Artikel-Nr.:</b></td><td>{{ article.article_nr }}</td></tr>
        <tr><td><b>Erstellt:</b></td><td>{{ article.created }}</td></tr>
        <tr><td><b>MWSt:</b></td><td>{{ article.vat }}</td></tr>
        <tr><td><b>Barcode:</b></td><td>{{ article.barcode }}</td></tr>
        <tr><td><b>Stückliste:</b></td><td>{{ article.mainart }}</td></tr>
        <tr><td><b>Verfügbar:</b></td><td>{{ article.stock }}</td></tr>
        <tr><td><b>Nachbestellt:</b></td><td><font-awesome-icon v-if="article.reordered" icon="check"/></td></tr>
        <tr><td valign="top"><b>Zusatzfelder:</b></td><td>
          <table>
              <tr v-for="(v,k) in article.extras" :key="k">
                <td>{{ k }}</td><td>{{ v }}</td>
              </tr>
          </table>
        </td></tr>
        <tr><td valign="top"><b>Verkaufseinheiten:</b></td><td>
          <table class="datalist">
              <tr v-for="item in article.quantities" :key="item.map_desc_id">
                <td>{{ item.desc }}</td><td>{{ item.multi }}</td>
              </tr>
          </table>
        </td></tr>
        <tr><td valign="top"><b>Freigaben:</b></td><td>
          <table class="datalist">
            <tr><td>bShop</td><td><font-awesome-icon v-if="article.flags.bshop" icon="check"/></td></tr>
            <tr><td>iHand</td><td><font-awesome-icon v-if="article.flags.ihand" icon="check"/></td></tr>
            <tr><td>iFair</td><td><font-awesome-icon v-if="article.flags.ifair" icon="check"/></td></tr>
          </table>
        </td></tr>
      </table>
    </div>
    <div class="col-md">
      <h4>Kategorien</h4>
      <ul class="list-group">
        <li class="list-group-item" :key="c.cat_id" v-for="c in article.cats">{{ c.cat_id }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleData',
  props: ["article"]
}
</script>
